import { Grid, TextField, Paper, Typography, Divider } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { ConsultationGuideData } from "../GuideDetailsDialog";

interface OperatorDataSectionProps {
  formData: ConsultationGuideData;
  onFieldChange: (name: string, value: any) => void;
}

export const OperatorDataSection = ({
  formData,
  onFieldChange,
}: OperatorDataSectionProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onFieldChange(name, value);
  };

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Dados da operadora
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextField
            required
            fullWidth
            label="Registro na ANS"
            name="registroANS"
            value={formData.registroANS}
            onChange={handleChange}
            size="small"
            helperText="Registro da operadora na ANS"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            required
            fullWidth
            label="Nome"
            name="nomeOperadora"
            value={formData.nomeOperadora}
            onChange={handleChange}
            size="small"
            helperText="Nome da operadora"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            required
            fullWidth
            label="Número guia (prestador)"
            name="numeroGuiaPrestador"
            value={formData.numeroGuiaPrestador}
            onChange={handleChange}
            size="small"
            helperText="Número atribuído pelo prestador"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            required
            fullWidth
            label="Número guia (operadora)"
            name="numeroGuiaOperadora"
            value={formData.numeroGuiaOperadora}
            onChange={handleChange}
            size="small"
            helperText="Número atribuído pela operadora"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePicker
            label="Data de emissão"
            value={formData?.dataEmissao || null}
            onChange={(date) => onFieldChange("dataEmissao", date)}
            slotProps={{
              textField: {
                size: "small",
                helperText: "Data de emissão da guia",
                required: true,
                fullWidth: true,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            label="Nro. lote"
            name="numeroLote"
            value={formData.numeroLote}
            onChange={handleChange}
            size="small"
            helperText="Número do lote de envio"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
